export function scrollToId(id) {
    let targetId = id;
    if (id === "contacto" && window.innerWidth < 1024) {
        targetId = "lead-form-fields";
    }
    const el = document.getElementById(targetId);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -76, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
